// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".exp-icon{width:24px;height:24px;margin-left:24px;margin-right:16px;object-view-box:0 0 24 24}.exp-desc{margin-top:32px}", ""]);
// Exports
module.exports = exports;
